package com.dotdrives.web.pages.onboarding

import com.dotdrives.controller.OnboardingUiState
import com.dotdrives.design.DotButtonVariant
import com.dotdrives.web.ui.DotBanner
import com.dotdrives.web.ui.DotButton
import com.dotdrives.web.ui.DotTextField
import react.FC
import react.Props
import react.dom.aria.AriaPressed
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.form
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

private val orgKinds = listOf(
    "nonprofit" to "Nonprofit",
    "ministry" to "Ministry",
    "school" to "School",
    "other" to "Other",
)

external interface OrgStepProps : Props {
    var state: OnboardingUiState
    var onOrgChange: (String, String) -> Unit
    var onBack: () -> Unit
    var onContinue: () -> Unit
}

val OrgStep = FC<OrgStepProps> { props ->
    val state = props.state

    form {
        className = ClassName("onboarding-step-form")
        onSubmit = { event ->
            event.preventDefault()
            props.onContinue()
        }

        div {
            className = ClassName("onboarding-step-meta dot-meta")
            +"STEP 2 OF 4"
        }
        h1 {
            className = ClassName("onboarding-step-title dot-heading")
            +"Create your organization"
        }
        p {
            className = ClassName("onboarding-step-copy")
            +"You can invite your team in the next step. Already invited? "
            span {
                className = ClassName("onboarding-display-link")
                title = "Ask your admin for an invite"
                +"Join an existing org"
            }
        }

        state.error?.let { message ->
            DotBanner {
                this.message = message
            }
        }

        DotTextField {
            value = state.orgName
            onValueChange = { props.onOrgChange(it, state.orgKind) }
            label = "Organization name"
            placeholder = "Hope Collective"
        }

        div {
            className = ClassName("onboarding-field-group")
            div {
                className = ClassName("onboarding-field-label dot-label")
                +"What kind of organization?"
            }
            div {
                className = ClassName("onboarding-chip-row")
                orgKinds.forEach { (value, label) ->
                    val selected = state.orgKind == value
                    button {
                        type = ButtonType.buttonType
                        className = ClassName(
                            "onboarding-chip" + if (selected) " onboarding-chip-selected" else "",
                        )
                        ariaPressed = selected.unsafeCast<AriaPressed>()
                        onClick = { props.onOrgChange(state.orgName, value) }
                        +(label + if (selected) " ✓" else "")
                    }
                }
            }
        }

        div {
            className = ClassName("onboarding-field-group")
            div {
                className = ClassName("onboarding-field-label dot-label")
                +"Fundraising process"
            }
            div {
                className = ClassName("onboarding-process-card")
                span {
                    className = ClassName("onboarding-process-icon")
                    ariaHidden = true
                    +"🧭"
                }
                div {
                    className = ClassName("onboarding-process-copy")
                    div {
                        className = ClassName("onboarding-process-title")
                        +"Start with the proven five phases"
                    }
                    div {
                        className = ClassName("onboarding-process-subtitle")
                        +"Identify · Connect · Ask · Close · Steward — customize anytime"
                    }
                }
                span {
                    className = ClassName("onboarding-process-check")
                    ariaHidden = true
                    +"✓"
                }
            }
        }

        div {
            className = ClassName("onboarding-actions")
            DotButton {
                text = "← Back"
                onClick = props.onBack
                variant = DotButtonVariant.Secondary
                className = "onboarding-action-secondary"
            }
            DotButton {
                text = "Continue → Invite your team"
                onClick = props.onContinue
                loading = state.loading
                enabled = state.canSubmitOrg
                className = "onboarding-action-primary"
            }
        }
    }
}
